import React from 'react';
import { Box, LinearProgress, Paper } from '@mui/material';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import { dataGridLocaleConfig } from '../config/data-grid-locale';

// Props comuns de todas as grades; espalhar no <DataGrid {...dataGridDefaults} ...>
export const dataGridDefaults = {
    localeText: dataGridLocaleConfig,
    components: { LoadingOverlay: LinearProgress },
    disableRowSelectionOnClick: true,
    columnVisibilityModel: { id: false },
    pageSizeOptions: [10, 25, 50, 100],
    sx: { flex: 1 },
};

// Grade com altura fixa e botão "+" posicionado abaixo, sem sobrepor a paginação
export function GridPanel({ children, addLabel, onAdd }: { children: React.ReactNode; addLabel?: string; onAdd?: () => void }) {
    return (
        <Box sx={{ position: 'relative', pb: onAdd ? '28px' : 0 }}>
            <Paper sx={{ p: 2, height: '500px', display: 'flex', flexDirection: 'column' }}>
                {children}
            </Paper>
            {onAdd && (
                <SpeedDial ariaLabel={addLabel || 'Adicionar'} sx={{ position: 'absolute', bottom: 0, right: 16 }} onClick={onAdd} icon={<SpeedDialIcon />} />
            )}
        </Box>
    );
}
